import { Box } from '@mui/material'
import { SeparatorProps } from './Separator.types'

export const Separator = ({ height }: SeparatorProps) => {
  return (
    <Box
      sx={{
        borderLeft: '1px solid',
        marginLeft: '24px',
        marginRight: '24px',
        opacity: 0.34,
        height: height,
      }}
    />
  )
}
